"use strict";
var Observable_1 = require("../../Observable");
var count_1 = require("../../operator/count");
Observable_1.Observable.prototype.count = count_1.count;
//# sourceMappingURL=count.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/count.js
 ** module id = 282
 ** module chunks = 1
 **/